import z from "zod";

export const agentCoverageSchema = z.object({
  payer: z.string().min(1),
  plan: z.string().nullable(),
});

export enum RelationshipToSubscriber {
  SELF = "Self",
  SPOUSE = "Spouse",
  CHILD = "Child",
  OTHER = "Other",
}

export const relationshipToSubscriberSchema = z.nativeEnum(RelationshipToSubscriber);

export function parseRelationshipToSubscriber(value: string | null | undefined): RelationshipToSubscriber | null {
  const normalized = value?.trim().toLowerCase();

  if (!normalized) return null;

  if (normalized.includes("spouse")) return RelationshipToSubscriber.SPOUSE;
  if (normalized.includes("child")) return RelationshipToSubscriber.CHILD;
  if (normalized === RelationshipToSubscriber.SELF.toLowerCase()) return RelationshipToSubscriber.SELF;

  return RelationshipToSubscriber.OTHER;
}

function coverageNameTokens(value: string): string {
  return ` ${value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim()} `;
}

/**
 * One spoken label for a payer and plan. EHR plan names often already carry the payer
 * ("Aetna" + "Aetna PPO"), so joining both would repeat it; the more specific name wins.
 */
export function getCoverageSpokenName({ payer, plan }: { payer: string; plan?: string | null }): string {
  const trimmedPayer = payer.trim();
  const trimmedPlan = plan?.trim();

  if (!trimmedPlan) return trimmedPayer;

  const payerTokens = coverageNameTokens(trimmedPayer);
  const planTokens = coverageNameTokens(trimmedPlan);

  if (planTokens.includes(payerTokens)) return trimmedPlan;
  if (payerTokens.includes(planTokens)) return trimmedPayer;

  return `${trimmedPayer} ${trimmedPlan}`;
}
